export default "/images/vendor/flag-icon-css/flags/4x3/id.svg?a5fb3413ae797b940643b1c3d62a57ee";